import { shape, string, oneOf } from 'prop-types';

export default shape({
  columnName: string.isRequired,
  direction: oneOf(['asc', 'desc'])
});
